import { render, staticRenderFns } from "./TutorEdit.vue?vue&type=template&id=f9a1ad04"
import script from "./TutorEdit.vue?vue&type=script&lang=ts"
export * from "./TutorEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports